/* eslint-disable no-undef */
import {createStore, applyMiddleware, combineReducers} from 'redux';

import {composeWithDevTools} from 'redux-devtools-extension';
import {connectRouter, routerMiddleware} from 'connected-react-router';
import {createBrowserHistory} from 'history';

import logger from 'redux-logger';

import appReducer from 'containers/App/redux/reducer';
import templateReducer from 'containers/ChooseTemplatePage/reducer';
import wisbitReducer from 'containers/WisbitPage/redux/reducer';
import manageUserReducer from 'containers/ManageUserPage/redux/reducer';
import manageWisbitReducer from 'containers/ManageWisbitPage/redux/reducer';
import manageOrganizationReducer from 'containers/ManageOrganizationPage/redux/reducer';
import errorReducer from 'containers/ErrorPage/reducer';

import displayError from 'middlewares/displayError';
import thunk from 'redux-thunk';
import {ACTION_LOGOUT} from './actions';
import {clearCookies} from '../utils/cookies';

export const history = createBrowserHistory();

const combinedReducer = combineReducers({
  router: connectRouter(history),
  app: appReducer,
  template: templateReducer,
  wisbit: wisbitReducer,
  manageUser: manageUserReducer,
  manageWisbit: manageWisbitReducer,
  manageOrganization: manageOrganizationReducer,
  error: errorReducer,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const rootReducer = (state: any, action: any) => {
  if (action.type === ACTION_LOGOUT) {
    // if logging out, reset all reducers
    clearCookies();
    state = undefined;
  }
  return combinedReducer(state, action);
};

export function configureStore() {
  const middleware = [routerMiddleware(history), displayError, thunk];

  if (process.env.NODE_ENV === 'development') {
    middleware.push(logger);
  }

  const store = createStore(
    rootReducer,
    composeWithDevTools(applyMiddleware(...middleware))
  );

  return {store};
}
